import React, { useEffect, useRef, useState } from "react";

import { TIMER_VALUE } from "../constants";
import styles from "./verticalStepper.module.scss";

interface Props {
  timerValue?: number;
  callBack?: () => void;
  children?: React.ReactNode;
}

const Timer: React.FC<Props> = ({
  timerValue = TIMER_VALUE,
  callBack,
  children,
}: Props): JSX.Element => {
  const timerRef = useRef<ReturnType<typeof setInterval> | null>(null);
  const [minutes, setMinutes] = useState<number>(Math.floor(timerValue / 60));
  const [seconds, setSeconds] = useState<number>(timerValue % 60);

  useEffect(() => {
    if (timerValue > 0) {
      timerRef.current = setInterval(() => {
        if (minutes === 0 && seconds === 0) {
          if (callBack) callBack();
          clearInterval(timerRef.current!);
        } else {
          if (seconds === 0) {
            setMinutes(minutes - 1);
            setSeconds(59);
          } else {
            setSeconds(seconds - 1);
          }
        }
      }, 1000);
    } else {
      if (timerRef.current) clearInterval(timerRef.current);
    }

    return () => {
      if (timerRef.current) clearInterval(timerRef.current);
    };
  }, [callBack, minutes, seconds, timerValue]);

  // Format the time as "mm:ss"
  const formattedTime = `${minutes.toString().padStart(2, "0")}:${seconds
    .toString()
    .padStart(2, "0")}`;

  return (
    <div className={styles.timer_container}>
      <p className={"p2"}>
        {children} <span className={"subtitle2"}>{formattedTime}</span>
      </p>
    </div>
  );
};

export default Timer;
